import { createFileRoute } from "@tanstack/react-router";

import { PocEnvironmentPage } from "@/features/poc-environment/poc-environment-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
// 画面本体は企業側 (`enterprise/poc-environment.tsx`) と共通。
export const Route = createFileRoute("/_authenticated/member/poc-environment")({
  staticData: { crumb: { label: STATIC_LABELS.pocEnvironment } },
  component: PocEnvironmentPage,
});
